import { ObjectHelper } from 'Code/Helpers/ObjectHelper';

export class ArrayNotContainsObjectWithPropertyBaseValueConverter {
    toView(array, configuration) {
        if (ObjectHelper.IsNullOrUndefined(array) || array.length <= 0)
        {
            return true;
        }
        return (array.filter((item) => item[configuration.propertyName] == configuration.value).length <= 0)
    }
}